import { createMuiTheme } from '@material-ui/core/styles'
// import purple from "@material-ui/core/colors/purple";

const theme = createMuiTheme({
  palette: {
    primary: { main: '#80C343' },
    secondary: { main: '#c6ff00' },
  },
})

export default theme
